/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_A1dInputs */

const en_mk_sol_operasional_a1d = /** @type {(inputs: Mk_Sol_Operasional_A1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runs the daily recaps and reconciliations, flagging the gaps a person needs to look at.`)
};

const id_mk_sol_operasional_a1d = /** @type {(inputs: Mk_Sol_Operasional_A1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menjalankan rekap dan rekonsiliasi harian, menandai selisih yang perlu diperiksa manusia.`)
};

/**
* | output |
* | --- |
* | "Runs the daily recaps and reconciliations, flagging the gaps a person needs to look at." |
*
* @param {Mk_Sol_Operasional_A1dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_a1d = /** @type {((inputs?: Mk_Sol_Operasional_A1dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_A1dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_a1d(inputs)
	return en_mk_sol_operasional_a1d(inputs)
});